export default __webpack_public_path__ + "static/media/illustration-study-3-n-m@2x.fd5ccca5.webp";